import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import OrderSidebar from "./orders/OrderSidebar";
import { changePassword } from "../actions";

class ChangePassword extends React.Component {
  renderError({ error, touched }) {
    if (touched && error) {
      return <div className="ui error message text-danger">{error}</div>;
    }
  }

  renderInput = ({ input, label, inputId, placeholder, type, meta }) => {
    const className = `field ${meta.error && meta.touched ? "error" : ""}`;
    return (
      <div className={className}>
        <label htmlFor={inputId}>{label}</label>
        <input
          type={type}
          {...input}
          title={label}
          id={inputId}
          autoComplete="off"
          placeholder={placeholder}
        />
        {this.renderError(meta)}
      </div>
    );
  };

  onSubmit = (formValues) => {
    this.props.changePassword(formValues);
  };

  render() {
    const getToken = localStorage.getItem("token");
    if (!getToken || getToken === "undefined" || getToken === "null") {
      return <Navigate to="/" />;
    }
    return (
      <div>
        <div className="w-100">
          <img
            src="./images/order-list-bg.png"
            alt="order-list-bg"
            className="img-fluid order-list-bg__image"
          />
        </div>

        <section className="our-menu py-150">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                <div className="our-menu__filter">
                  <OrderSidebar />
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 sidebar__form profile">
                <div className="order-list__wrapper">
                  <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                    <Field
                      name="cur_password"
                      type="password"
                      placeholder="Current Password"
                      component={this.renderInput}
                    />
                    <Field
                      name="password"
                      type="password"
                      placeholder="Password"
                      component={this.renderInput}
                    />
                    <button
                      type="submit"
                      className="orange__btn text-uppercase"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const validate = (formValues) => {
  const errors = {};

  if (!formValues.cur_password) {
    errors.cur_password = "Enter Current Password";
  } else if (formValues.cur_password.length < 5) {
    errors.cur_password = "Must be 5 characters or more";
  }

  if (!formValues.password) {
    errors.password = "Enter Password";
  } else if (formValues.password.length < 5) {
    errors.password = "Must be 5 characters or more";
  }

  return errors;
};

const formData = reduxForm({
  validate,
  form: "changePassword",
})(ChangePassword);

export default connect(null, {
  changePassword,
})(formData);
